import _ from "lodash";
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import FormHelperText from "@mui/material/FormHelperText";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";

const FormPasswordUIItem = ({
    code,
    label,
    initValue,
    value,
    disabled,
    readOnly,
    required,
    unit,
    error,
    errorMessage,
    placeholder,
    handleUpdate }) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    return (<><
        div style={{ height: unit ? 4 : 0 }} />
        <FormControl
            placeholder={placeholder}
            style={{ marginTop: 16 }}
            fullWidth>            
            <TextField
                disabled={disabled}
                readOnly={readOnly}
                error={error}
                defaultValue={initValue}
                value={value}
                label={label}
                variant="outlined"
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                onChange={({ target }) => {
                    let { value } = target;
                    handleUpdate(code, value);
                }}
                InputProps={{ // <-- This is where the toggle button is added.
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                            >
                                {showPassword ? <RemoveRedEyeIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
            {
                error && <FormHelperText error id={`outlined-${code}-error`}>
                    {errorMessage}
                </FormHelperText>
            }
        </FormControl>
    </>);
}

export default FormPasswordUIItem;